module.exports = __webpack_public_path__ + "img/upsell-hifi-bg-desktop.73f2e2d.jpg";